import stylesColors from 'common/styles/styles.colors';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import NewCruiseTable from './cruise-table/new';
import OriginalCruiseTable from './cruise-table/original';
import { ScheduleCardHeader, ScheduleCardHeaderRight } from '../../style';

export default function CruiseCard() {
  const { t } = useTranslation();
  return (
    <CardSection>
      <ScheduleCardHeader $style={headerStyle}>
        <Text variant="HeadingXSmall">{t('ticketSales:cruise_detail')}</Text>
        <ScheduleCardHeaderRight>
          <Input
            type="check-box"
            name="cruiseSales.0.reminder"
            label={t('ticketSales:set_reminder')}
            noMargin
            disabled
          />
        </ScheduleCardHeaderRight>
      </ScheduleCardHeader>
      <Separator gap={16} direction="vertical">
        <Text
          variant="LabelMedium"
          $style={{ color: stylesColors.primaryDefault }}
        >
          {t('common:original_extra', { extra: t('common:schedule') })}
        </Text>
      </Separator>
      <OriginalCruiseTable />
      <Separator gap={16} direction="vertical">
        <Text
          variant="LabelMedium"
          $style={{ color: stylesColors.primaryDefault }}
        >
          {t('common:new_extra', { extra: t('common:schedule') })}
        </Text>
      </Separator>
      <NewCruiseTable />
    </CardSection>
  );
}

const headerStyle: StyleObject | any = {
  flexDirection: 'column',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
};
